import { styled, Box } from '@mui/material';

export const StyledFeatureContentBox = styled(Box)({
  padding: '32px 80px 32px 32px',
  textAlign: 'justify',
  maxWidth: '100%',
  boxSizing: 'border-box',
});
